export default "<ion-label>{{ montoPercent }} %</ion-label>\n<!-- <ion-label>{{ montoPercent | percent:'1.4-4'}}</ion-label> -->";